import * as actionTypes from '../actions/actionTypes';
import CookieJar from '../../utils/cookie_jar';

const initialState = {
  preferredLang: CookieJar.get('preferred_lang')
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PREFERRED_LANG_CHANGED:
      return {
        ...state,
        preferredLang: action.preferredLang
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./app/javascript/app/store/reducers/localize.js